<template>
    <div id="requestDesktop">
        <div class="request-info">
            <Panel :title="$t('requests.request_details')" id="resquest">
                <div class="top" v-if="request">
                    <div class="details-left">

                        <div class="group">
                            <label>{{$t('requests.date')}}</label>
                            <span class="value">{{request.createdAt.format("DD/MM/YYYY - HH:mm")}}</span>
                        </div>
                        <div class="group" v-if="request.property">
                            <label>{{$t('address.building')}}</label>
                            <span class="value">{{request.property}}</span>
                        </div>
                        <div class="group" v-if="request.unit">
                            <label>{{$t('address.unit')}}</label>
                            <span class="value">{{request.unit}}</span>
                        </div>
                        <div class="group" v-if="request.phoneNumber">
                            <label>{{$t('user.phone')}}</label>
                            <span class="value">{{request.phoneNumber}}</span>
                        </div>

                    </div>

                    <div class="details-right" v-if="request">

                        <div class="group" v-if="requestCategory">
                            <label>{{$t('requests.category.lv1')}}</label>
                            <span class="value">{{$to(requestCategory)}}</span>
                        </div>
                        <div class="group">
                            <label>{{$t('requests.urgent')}}</label>
                            <span class="value">{{request.emergency ? $t('yes') : $t('no')}}</span>
                        </div>
                        <div class="group">
                            <label>{{$t('requests.absent')}}</label>
                            <span class="value">{{request.canAccessIfAbsent ? $t('yes') : $t('no')}}</span>
                        </div>
                        <div class="group">
                            <label>{{$t('requests.alarm')}}</label>
                            <span class="value">{{ request.alarm ? $t('yes') : $t('no') }}</span>
                        </div>
                        <div class="group" v-if="request.alarm">
                            <label>{{$t('requests.alarmCode')}}</label>
                            <span class="value">{{request.alarmCode || '??'}}</span>
                        </div>
                        <div class="group">
                            <label>{{$t('requests.animal')}}</label>
                            <span class="value">{{request.animal ? $t('yes') : $t('no')}}</span>
                        </div>


                    </div>

                    <div class="details-info" v-if="request">
                        <div class="group" v-if="request.body">
                            <label>{{$t('form.comments_precision')}}</label>
                            <span class="value">{{request.body}}</span>
                        </div>
                        <div class="group" v-if="request.image">
                            <label>{{$t('form.photo')}}</label>
                            <img :src="CONFIG.urlFiles + request.image" alt="">
                        </div>
                    </div>
                </div>
            </Panel>

            <Panel :title="$t('requests.answer')" v-if="request && request.decisionNote" >
                <div>
                    <span class="value">{{ request.decisionNote }}</span>
                </div>
            </Panel>

            <Panel :title="$t('requests.discussion')" v-if="request && (request.status === 'completed' || request.status === 'in_progress')">

                <div class="group" v-if="request && request.discussion && request.discussion.length > 0">
                    <label>{{$t('requests.messages')}}</label>
                    <div class="discussion">
                        <div class="message" v-for="line of request.discussion">
                            <div class="from" :class="{'current-user' : isCurrentUser(line.user)}">{{line.from}}</div>
                            <div class="content">{{line.msg}}</div>
                        </div>
                    </div>
                </div>
                <div class="group">
                    <label>{{$t('requests.reply')}}</label>
                    <textarea :value="userReply" class="reply-text" @input="$emit('update:userReply', $event.target.value)"/>
                </div>
                <div class="actions">
                    <button class="btn btn-primary reply-button" @click="reply"> {{$t('requests.send_reply')}} </button>
                </div>
            </Panel>

            <Panel :title="$t('requests.discussion')" v-if="request && !(request.status === 'completed' || request.status === 'in_progress')">
                <div class="description">
                    {{$t('requests.not_available')}}
                </div>
            </Panel>
        </div>
        <div class="buttons">
            <div class="btn btn-primary" @click="cancel" v-if="request && !request.isDone()">{{$t("requests.cancel")}}</div>
            <div class="btn btn-secondary" @click="back">{{$t("requests.back")}}</div>
        </div>

    </div>
</template>

<script>
    import Requests from "../../../core/Requests";
    import Panel from "../Panel";
    import { DateTime } from "luxon";

    export default {
        name: "RequestDesktop",

        components: {
            Panel
        },

        props: {
            leftPad: Function,
            back: Function,
            cancel: Function,
            reply: Function,
            isCurrentUser: Function,

            request: Object,
            userReply: String

        },

        data() {
            return {
                Requests,
                CONFIG
            };
        },

        computed: {
            thirdCategoryDefined() {
                return this.request && this.request.categories[0] && this.request.categories[1] && this.request.categories[2];
            },
            secondCategoryDefined() {
                return this.request && this.request.categories[0] && this.request.categories[1];
            },
            firstCategoryDefined() {
                return this.request && this.request.categories[0];
            },
            requestType() {
                if (this.thirdCategoryDefined) {
                    return this.request.categories[0];
                }
                return null;
            },
            requestCategory() {
                if (this.thirdCategoryDefined) {
                    return this.request.categories[2];
                }
                if (this.secondCategoryDefined) {
                    return this.request.categories[1];
                }
                if (this.firstCategoryDefined) {
                    return this.request.categories[0];
                }
                return null;
            }
        },

        methods: {
            readableDateTime(date) {
                return date
                    ? DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss').toLocaleString(DateTime.DATETIME_MED)
                    : null;
            },

        }
    };
</script>

<style lang="scss" scoped>

    #requestDesktop {
        padding: 30px 60px 30px 60px ;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        position: relative;

    }
    .request-info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }
    panel {
        border-radius: 2px;
    }

    .group {
        display: flex;

        flex-direction: column;
        flex-grow: 1;
        margin-bottom: 10px;
        label {
            font-size: 14px;
        }

        img {
            max-width: 100%;
            max-height: 200px;
            margin-top: 7px;
            border-radius: 10px;
            background-size: contain;
            background-repeat: no-repeat;
        }
    }

    .discussion {
        margin-top: 4px;
        .message {
            display: flex;
            flex-direction: column;
            padding-left: 5px;
            background-color: #f2f3f4;

            &:nth-child(even) {
                background-color: #e2e3e4;
            }
        }
        .from {
            padding: 12px 12px 8px 12px;
            color: #676767;
            font-size: 14px;
            height: 100%;
            font-weight: bold;

            &.current-user {
                color: black;
            }
        }
        .content {
            padding: 0 12px 12px;
        }
    }
    .reply-text {
        margin-top: 4px;
    }

    .reply-button {
        min-width: 125px;
    }

    .top {
        display: flex;
        & > div:not(:last-of-type) {
            margin-right: 40px;
        }
    }
    .details-left {}
    .details-right {
        flex-grow: 1;
        flex-basis: 0;
        display: flex;
        flex-direction: column;
    }
    .details-info {
        display: flex;
        flex-direction: column;
        flex-grow: 1.2;
        flex-basis: 0;
        span {
            flex-grow: 1;
        }
    }

    .buttons {
        display: flex;
        padding: 20px 0;
        .btn:not(:last-of-type) {
            margin-right: 20px;
        }
    }


</style>
